module.exports = __webpack_public_path__ + "img/20231123152242953xmp.5f31cb26.jpg";